export default {
  conversation_dnd_message: '{name} sedang Tidak Dapat Diganggu',
  conversation_dnd_message_with_time:
    '{name} Tidak Dapat Diganggu sampai {time, time, short}',
  conversation_dnd_message_tooltip_content:
    '{name} tidak akan menerima pemberitahuan',
};
